<template>
  <div class="p-user">
    <div class="g-header">
      <el-page-header @back="$router.push({ path: '/' })">
        <div slot="content" class="info-box">
          <el-avatar shape="square" icon="el-icon-user" style="display: inline-flex" :src="info.avatar"></el-avatar>
          <div class="text">
            <p style="font-size: 12px; color: #000;">{{ info.company }}</p>
            <div style="display: flex;">
              <p style="font-size: 12px; color: #999;">
                {{ info.name }}
              </p>
            </div>
          </div>
          <svg-icon @click.native="dialogVisible = true" class="info-btn" name="card"></svg-icon>
        </div>
        <div slot="title">
          <i class="el-icon-arrow-left"></i>
          返回
        </div>
      </el-page-header>
      <div class="search-box">
        <el-input placeholder="请输入查找的内容" v-model="keyword" ref="input" size="mini" @keyup.native.enter="changeHandle" class="input-with-select">
          <el-select @change="changeHandle" v-model="tags" slot="prepend">
            <el-option v-for="item in searchTypes" :key="item.label" :label="item.label" :value="item.label"></el-option>
          </el-select>
          <el-button @click="changeHandle" slot="append" class="search-btn" :icon="loading ? 'el-icon-loading' : 'el-icon-search'"></el-button>
        </el-input>
      </div>
    </div>
    <div class="scroll-body">
      <template v-if="totalCount === 0 && !loading">
        <el-divider>暂无更多消息</el-divider>
      </template>
      <ul class="infinite-list">
        <li v-for="item in messageList" :key="item.msgId">
          <message :info="item" :keyword="keyword" :types="searchTypes" @click-btn="messageClickHandle" :hide-btns="['topIcon']" :is-top="item.isTop"></message>
        </li>
      </ul>
      <el-divider v-if="totalCount && totalCount <= this.messageList.length && !loading">暂无更多信息</el-divider>
    </div>
    <div class="g-footer">
      <edit-box :reply.sync="reply" :ats.sync="ats" :types="[]" @send="sendMessage"></edit-box>
    </div>
    <el-dialog width="95%" :visible.sync="dialogVisible" custom-class="info-dialog">
      <div class="base-info">
        <el-avatar shape="square" icon="el-icon-user" style="display: inline-flex;" :src="info.avatar"></el-avatar>
        <div class="text">
          <p style="font-size: 12px; color: #000;">{{ info.company }}</p>
          <p style="font-size: 12px; color: #999;">{{ info.name }}</p>
        </div>
      </div>
      <div class="other-info">
        <h3>公司信息</h3>
        <div><span>简介</span>{{ companyInfo.intro }}</div>
        <div><span>手机号</span>{{ companyInfo.phone }}</div>
        <div><span>座机</span>{{ companyInfo.telephone }}</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Chat from "@/api/chat";
import Message from "@/components/Message";
import EditBox from "@/components/EditBox";
import Bus from "@/components/Bus";
import User from "@/api/user";
import Tags from "@/components/tags";
import Utils from "@/utils";

export default {
  data() {
    return {
      ats: [],
      dialogVisible: false,
      reply: { id: "" },
      pageSize: 20,
      pageIndex: 0,
      editing: false,
      totalCount: -1,
      loading: false,
      keyword: "",
      tags: "",
      messageList: [],
      msgIdList: [],
      info: {},
      companyInfo: {}
    };
  },
  components: { Message, EditBox },
  computed: {
    searchTypes() {
      const searchTypes = [
        {
          label: "全部",
          value: ""
        },
        {
          label: "@Ta",
          value: "AT"
        }
      ];
      Tags.map(item => searchTypes.push(item));
      searchTypes.push({
        label: "红包",
        value: "redEnvelope",
        color: "#e74c3c"
      });
      return searchTypes;
    },
    isOwn() {
      const { id } = this.$route.query;
      return id === this.userId;
    },
    types() {
      const types = [];
      Tags.map(item => types.push(item));
      types.push({
        label: "红包",
        value: "redEnvelope",
        color: "#e74c3c"
      });
      return types;
    },
    searchType() {
      return this.searchTypes.find(item => this.tags === item.label);
    },
    userId() {
      return this.$store.state.userId;
    },
    token() {
      return this.$store.state.token;
    }
  },
  watch: {
    token: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.searchFromUrl();
          this.getUserInfo();
          this.getMessageList();
        }
      }
    }
  },
  methods: {
    back() {
      if (this.hasChange === true) {
        this.$router.push({ path: "/" });
      } else {
        this.$router.go(-1);
      }
    },
    scrollHandle() {
      if (Utils.inBottom() && !this.loading) {
        if (this.messageList.length < this.totalCount) {
          this.more();
        }
      }
    },
    changeHandle() {
      this.pageIndex = 1;
      this.messageList = [];
      this.msgIdList = [];
      this.loading = false;
      this.totalCount = -1;
      this.getMessageList();
      this.$nextTick(() => this.$refs.input.focus());
      this.$router.push({
        path: "/user",
        query: {
          id: this.info.id,
          keyword: this.keyword,
          type: this.searchType.value
        }
      });
    },
    async getUserInfo() {
      const { id } = this.$route.query;
      await User.info(id).then(res => {
        this.info = {
          id: res.UserGuid,
          company: res.CompanyName,
          companyId: res.CompanyId,
          avatar: res.UserAvatarUrl,
          name: res.UserName,
          nickName: res.NickName
        };
        // if (this.userId === id) {
        //   this.ats = [];
        // } else {
        //   this.ats = [this.info];
        // }
      });
      this.companyInfo = await User.companyInfo(this.info.companyId).then(response => {
        const data = response;
        return {
          companyName: data.CompanyName,
          address: data.Address,
          phone: data.Phone,
          email: data.Email,
          telephone: data.Telephone,
          qq: data.QQ,
          intro: data.Introduction
        };
      });
    },
    searchFromUrl() {
      const { type, keyword, id } = this.$route.query;
      this.info.id = id;
      this.searchTypes.find(item => {
        if (type === item.value) {
          this.tags = item.label;
        }
      });
      this.tags = this.tags || "全部";
      this.keyword = keyword || "";
    },
    messageClickHandle(e) {
      if (e.type === "at") {
        const findItem = this.ats.find(item => item.id === e.info.id);
        !findItem && this.ats.unshift({ id: e.info.id, name: e.info.name });
      }
      if (e.type === "reply") {
        this.reply = {
          id: e.info.msgId,
          txt: e.info.txt
        };
      }
    },
    sendMessage(message) {
      Bus.$emit("sendMessage", message);
    },
    more() {
      this.pageIndex += 1;
      this.getMessageList();
    },
    async getMessageList() {
      if (this.loading) {
        return false;
      }
      this.loading = true;
      const postData = {
        pageIndex: this.pageIndex,
        userId: this.info.id,
        keyword: this.keyword,
        tags: this.tags,
        orderby: "time"
      };
      if (postData.tags === "全部") {
        postData.tags = "";
        postData.searchType = "";
      }
      if (postData.tags === "AT" || postData.tags === "@Ta") {
        postData.tags = "";
        postData.searchType = "AT";
      }
      let result = this.info.id === this.userId ? await Chat.myHistory(postData) : await Chat.search(postData);
      this.loading = false;
      this.totalCount = result.TotalCount;
      if (result.ResultList.length) {
        result.ResultList.map(item => {
          item.time = this.$timeFormat(item.t);
          if (!this.msgIdList.includes(item.msgId)) {
            this.messageList.push(item);
            this.msgIdList.push(item.msgId);
          }
        });
        // 更新已读消息
        if (postData.searchType === "AT") {
          Chat.updateUnRead(this.messageList[0].msgId);
        }
      }
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollHandle, true);
  },
  mounted() {
    this.$nextTick(() => this.$refs.input.focus());
    window.addEventListener("scroll", this.scrollHandle, true);
  }
};
</script>
<style lang="scss">
.p-user {
  .el-page-header__left {
    align-items: center;
  }
  .el-page-header {
    background-color: #f5f5f5;
    .el-icon-back {
      display: none;
    }
  }
  .el-dialog__body {
    padding: 0px 30px 20px 30px;
  }
  .info-btn {
    position: absolute;
    cursor: pointer;
    right: 10px;
    font-size: 20px;
    fill: #0091ea;
  }
  .search-box {
    padding: 0px 5px 5px 5px;
    background-color: #f5f5f5;
  }
  .search-btn {
    width: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  ul {
    li {
      border-bottom: 1px solid #eee;
    }
    .m-message {
      padding: 0 10px;
    }
    li:last-child {
      border-bottom: none;
    }
  }
  .info-box {
    display: flex;
    font-size: 12px;
    align-items: center;
    line-height: 14px;
    .el-avatar {
      width: 28px;
      height: 28px;
    }
    .text {
      padding-left: 10px;
      display: inline-block;
      white-space: nowrap;
      font-size: 14px;
      line-height: 14px;
    }
  }

  .el-select .el-input {
    width: 80px;
  }
  .el-input-group__prepend {
    background-color: #fff;
  }
  .scroll-body {
    position: relative;
    padding-top: 72px;
    padding-bottom: 90px;
    height: 100%;
    overflow: auto;
  }
  .info-dialog {
    border-radius: 4px;
    .el-icon-close {
      margin-top: -10px;
      font-size: 26px;
    }
    .base-info {
      display: flex;
      font-size: 12px;
      align-items: flex-start;
      line-height: 14px;
      .el-avatar {
        width: 40px;
        height: 40px;
        border-radius: 2px;
        border: 1px solid #e6e6e6;
      }
      .text {
        padding-left: 8px;
        display: inline-block;
        font-size: 14px;
        line-height: 16px;
      }
    }
    .other-info {
      h3 {
        margin-top: 16px;
        font-size: 14px;
        color: #333;
        margin-bottom: 5px;
        &:before {
          content: "";
          margin-right: 4px;
          width: 8px;
          height: 8px;
          display: inline-block;
          background-color: #ee7700;
        }
      }
      div {
        font-size: 12px;
        color: #333;
        line-height: 24px;
        span {
          display: inline-block;
          white-space: nowrap;
          width: 50px;
          color: #999;
        }
      }
    }
  }
}
</style>
